var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJoinDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 51,
    viewBox: "0 0 47 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.043 0.859375H0.0429688V50.8594H46.043V0.859375ZM28.822 25.1312H23.83V20.0752C23.83 19.8192 23.702 19.6912 23.446 19.6912H22.71C22.454 19.6912 22.326 19.8192 22.326 20.0752V25.1312H17.334C17.078 25.1312 16.95 25.2486 16.95 25.4832V26.1872C16.95 26.4219 17.078 26.5392 17.334 26.5392H22.326V31.5952C22.326 31.8512 22.454 31.9792 22.71 31.9792H23.446C23.702 31.9792 23.83 31.8512 23.83 31.5952V26.5392H28.822C29.078 26.5392 29.206 26.4219 29.206 26.1872V25.4832C29.206 25.2486 29.078 25.1312 28.822 25.1312Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinDefault);
export default __webpack_public_path__ + "static/media/join_default.89686ddb19ca23deddc9f2708394555b.svg";
export { ForwardRef as ReactComponent };